<script>
  let { ...rest } = $props();
</script>

<svg
  viewBox="0 0 24 24"
  width="24"
  height="24"
  fill="none"
  stroke="currentColor"
  stroke-width="2"
  stroke-linecap="round"
  stroke-linejoin="round"
  {...rest}
>
  <polyline points="6 9 12 15 18 9" />
</svg>
